/**
 * Blog post metadata for the news index page.
 *
 * Re-exports raw post data and provides environment-aware filtering.
 *
 * DRAFT POSTS:
 * Set `draft: true` to hide a post from production builds.
 * - In dev: Draft posts appear with a "DRAFT" badge
 * - In prod: Draft posts are filtered from listings
 *
 * Note: The route still exists in prod (just not linked). For true
 * exclusion, move the file out of src/routes/ entirely.
 */
import { isDev } from '$lib/config';
import { posts } from './posts-data';

// Re-export types and raw data
export type { PostMeta } from './posts-data';
export { posts } from './posts-data';

// Filter out drafts in production, keep all in dev
const visiblePosts = isDev ? posts : posts.filter((p) => !p.draft);

// Sort posts by date (newest first)
export const sortedPosts = [...visiblePosts].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
);

// Get featured posts (drafts can't be featured in prod)
export const featuredPosts = sortedPosts.filter((p) => p.featured && (isDev || !p.draft));

// Get regular (non-featured) posts
export const regularPosts = sortedPosts.filter((p) => !p.featured);
